import React from 'react'
import PropTypes from 'prop-types'

const Row3Columns = (props) => {
  return (
    <div className="form__group form__group--has-columns">
      <div className="form__column">
        {props.children[0]}
      </div>
      <div className="form__column">
        {props.children[1]}
      </div>
      <div className="form__column">
        {props.children[2]}
      </div>
    </div>
  )
}

Row3Columns.propTypes = {
  config: PropTypes.object.isRequired,
  children: PropTypes.array.isRequired,
}

export default Row3Columns


// WEBPACK FOOTER //
// ./src/components/FormTemplates/Group/Row3Columns.js